import { buildMenuCategories } from '@root/components/v2/SideOverlayTabMenu/buildMenuCategories';
import { Bug, LayoutList } from 'lucide-react';

export const FINDING_DETAILS_TABS = {
  overview: { label: 'Overview', icon: LayoutList },
  cve: { label: 'CVE details', icon: Bug },
};

// Vertical menu of the Findings side overlay. Only two tabs, so they are listed flat.
export const FINDING_DETAILS_MENU_CATEGORIES = buildMenuCategories(
  Object.keys(FINDING_DETAILS_TABS),
  undefined,
  key => ({ key, ...FINDING_DETAILS_TABS[key] }),
);
